export default "__VITE_ASSET__DMEOvD7e__"